import createCrudVuexModule from "@/store/crud";

const criteria = {
  department: [],
  process: [],
  datasource: [],
  dataCategory: [],
  data: [],
  datasubject: [],

  //

  directCollectMethod: [],
  otherCollectMethod: [],
  electronicStorage: [],
  physicalStorage: [],
  receiverGroup: [],
  thirdParty: [],
};

const setValue = (value) => {
  return value?.length > 0 ? [...value.map((v) => ({ _id: v._id, name: v.name, country: v.country, agreementType: v.agreementType }))] : [];
};

export const legalDocumentFilter = createCrudVuexModule({
  namespaced: true,
  path: "/gdpr/inventory",
  // persistent: ["criteria"],

  state: {
    criteria: {
      ...criteria,
    },

    abroad: false,
    thirdPartyDirection: null,
  },
  getters: {
    criteria: (state) => state.criteria,
    abroad: (state) => state.abroad,
    thirdPartyDirection: (state) => state.thirdPartyDirection,
  },
  mutations: {
    criteria: (state, value) => (state.criteria = value ? value : [...criteria]),

    department: (state, value) => (state.criteria.department = setValue(value)),
    process: (state, value) => (state.criteria.process = setValue(value)),
    datasource: (state, value) => (state.criteria.datasource = setValue(value)),
    dataCategory: (state, value) => (state.criteria.dataCategory = setValue(value)),
    data: (state, value) => (state.criteria.data = setValue(value)),
    datasubject: (state, value) => (state.criteria.datasubject = setValue(value)),
    //
    directCollectMethod: (state, value) => (state.criteria.directCollectMethod = setValue(value)),
    otherCollectMethod: (state, value) => (state.criteria.otherCollectMethod = setValue(value)),
    electronicStorage: (state, value) => (state.criteria.electronicStorage = setValue(value)),
    physicalStorage: (state, value) => (state.criteria.physicalStorage = setValue(value)),
    receiverGroup: (state, value) => (state.criteria.receiverGroup = setValue(value)),
    thirdParty: (state, value) => (state.criteria.thirdParty = setValue(value)),
    abroad: (state, value) => (state.abroad = !!value),
    thirdPartyDirection: (state, value) => (state.thirdPartyDirection = value),

    clear: (state, value) => (state.criteria = { ...criteria }),
  },
  actions: {},
});
